<template>
  <v-navigation-drawer app :value="value" :right="right">
    <!-- <div v-if="!right" style="min-height: var(--header-height)"></div> -->
    <div v-if="right" class="pa-3 mb-3 d-flex justify-end">
      <v-btn icon @click="eventClose">
        <v-icon>east</v-icon>
      </v-btn>
    </div>
    <div v-if="!right" class="pa-3 mb-3 d-flex justify-start">
      <v-btn icon @click="eventClose">
        <v-icon>west</v-icon>
      </v-btn>
    </div>
    <div
      v-if="$vuetify.breakpoint.smAndDown"
      class="cursor-pointer font-14 pl-4"
      @click="branchDialog"
    >
      สาขา: {{ dataDialog.branchINV }} {{ dataDialog.branchCode }}
      {{ dataDialog.branchName }}
      <v-icon>mdi-chevron-down</v-icon>
    </div>
    <MenuList :items="mainMenus" />

    <!-- div class="txt-bigger px-3 mt-5 mb-2">ข้อมูลแฟรนไชส์</div -->
    <!-- <MenuList :items="franchiseMenus" /> -->

    <!-- New menu layout : 24 Nov -->
    <!-- <MenuList :items="managerMenus" /> -->

    <!--div class="txt-bigger px-3 mt-5 mb-2">แจ้งเรื่อง/ติดตาม</div -->
    <!-- <MenuList :items="caseMenu" /> -->

    <!-- Todo disable comment this line -->
    <!-- <div class="txt-bigger px-3 mt-5 mb-2">เอกสาร</div>
    <MenuList :items="documentMenus" /> -->
  </v-navigation-drawer>
</template>

<script>
import {
  mainMenus,
  franchiseMenus,
  documentMenus,
  managerMenus,
  caseMenu,
  mainPage,
  mainSite,
} from "@/store/constants";
import MenuList from "./MenuList.vue";

export default {
  components: { MenuList },
  props: {
    value: {
      default: true,
    },
    right: {
      default: false,
    },
    dataDialog: {
      default: () => ({}),
    },
  },
  name: "SideMenu",
  data() {
    return {
      mainMenus,
      franchiseMenus,
      documentMenus,
      managerMenus,
      caseMenu,
      mainPage,
      mainSite,
    };
  },
  methods: {
    eventClose() {
      this.$emit("onClose");
    },
    branchDialog() {
      this.$emit("branchDialog");
    },
  },
};
</script>
